// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"102":"2cdf009e","532":"2cdf009e","815":"2cdf009e"}[chunkId] + ".chunk.css";
};